import { organisationConstants } from '../../../_constants';

const initialState = { updateManageMetricLoading: true, data: '', error: false };

export function UpdateManageMetric(state = initialState, action) {
    
    switch (action.type) {
        case organisationConstants.REQUEST_UPDATE_MANAGE_METRIC:
            return {
                updateManageMetricLoading: true,
                data: '',
                error: false
            };
        case organisationConstants.RECEIVE_UPDATE_MANAGE_METRIC:
            return {
                updateManageMetricLoading: false,
                data: action.manageMetricList,
                error: false
            };
        case organisationConstants.UPDATE_MANAGE_METRIC_ERROR:
            return {
                updateManageMetricLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageMetric/updateManageMetric.reducer.js